import { useQuery } from '@tanstack/react-query'
import { getShiftById } from 'api/shifts/getShiftById'
import { shiftDetailKey } from './keys'

export const useShiftByIdQuery = (shiftId: number | undefined) => {
  return useQuery({
    queryKey: shiftDetailKey(shiftId ?? 0),
    queryFn: () => getShiftById(shiftId ?? 0),
    enabled: !!shiftId,
  })
}
